//matches either just 'John Doe' or ('John Doe 1 some notes go here' and 'John Doe +1 some notes go here')
const FIRST_NAME = '([a-zA-Z]+)';
const FIRST_NAME_COUNT = '([a-zA-Z]+) \\+{0,1}([0-9]+)';
const FIRST_NAME_COUNT_NOTES = '([(|a-zA-Z]+) \\+{0,1}([0-9]+)(?: {0,1})([^\\n\\r]+)';
const FIRST_NAME_LAST_NAME = '([a-zA-Z]+) ([a-zA-Z]+)';
const FIRST_NAME_LAST_NAME_COUNT = '([a-zA-Z]+) ([a-zA-Z]+) \\+{0,1}([0-9]+)';
const FIRST_NAME_LAST_NAME_COUNT_NOTES = '([(|a-zA-Z]+) ([a-zA-Z]+) \\+{0,1}([0-9]+)(?: {0,1})([^\\n\\r]+)';

const ALL_REGEX = [
  FIRST_NAME,
  FIRST_NAME_COUNT,
  FIRST_NAME_COUNT_NOTES,
  FIRST_NAME_LAST_NAME,
  FIRST_NAME_LAST_NAME_COUNT,
  FIRST_NAME_LAST_NAME_COUNT_NOTES
];

const ADMISSION_GROUP_LINE_REGEX = new RegExp(`^(${ALL_REGEX.join('|')})$`, 'gi');

class AdmissionGroupLineParserService {
  parseLine(line) { //eslint-disable-line
    if (!line) throw new Error('admissionGroupLineParserService - parseLine() - line is required');

    const results = new RegExp(ADMISSION_GROUP_LINE_REGEX.source).exec(line);

    if (!results || !results.length || results.length !== 17) return null;

    let firstName;
    let lastName;
    let guestsExpectedUnisex;
    let notes;

    if (results[2]) {
      firstName = results[2];
    } else if (results[3] && results[4]) {
      firstName = results[3];
      guestsExpectedUnisex = results[4];
    } else if (results[5] && results[6] && results[7]) {
      firstName = results[5];
      guestsExpectedUnisex = results[6];
      notes = results[7];
    } else if (results[8] && results[9]) {
      firstName = results[8];
      lastName = results[9];
    } else if (results[10] && results[11] && results[12]) {
      firstName = results[10];
      lastName = results[11];
      guestsExpectedUnisex = results[12];
    } else if (results[13] && results[14] && results[15] && results[16]) {
      firstName = results[13];
      lastName = results[14];
      guestsExpectedUnisex = results[15];
      notes = results[16];
    }

    let name = `${(firstName || '').trim()} ${(lastName || '').trim()}`.trim();
    if (!name) name = '(No name)';

    return {
      name,
      guestsExpectedUnisex: guestsExpectedUnisex ? parseInt(guestsExpectedUnisex, 10) : 1,
      notes
    };
  }
}

AdmissionGroupLineParserService.$inject = [];

export default AdmissionGroupLineParserService;



// WEBPACK FOOTER //
// ./src/services/admissionGroupLineParserService.js